<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="d-flex flex-row justify-content-between align-items-start">
  <div class="icon">
    <img width="90" alt="alert" src="assets/img/SP_Icon_Alert.png" />
  </div>
  <button (click)="close()" mat-icon-button alt aria-label="Close" class="no-outline">
    <mat-icon title="Close" svgIcon="ic_clear_black_24px"></mat-icon>
  </button>
</div>
<div>
  <h2>{{ displayTitle }}</h2>
  <mat-expansion-panel class="messagebody">
    <mat-expansion-panel-header>
      <mat-panel-title> Error Details </mat-panel-title>
    </mat-expansion-panel-header>
    <p class="pre-wrap" [innerHtml]="displayMessage"></p>
  </mat-expansion-panel>
</div>
